export default "__VITE_PUBLIC_ASSET__18092fc9__"